<template>
	<div class="h-100">
		<div class="pb-7">
			<h1 class="text-center mb-2">Solicitar reembolso</h1>
			<p class="text-center">
				Para solicitar um reembolso preencha as informações referentes à nota fiscal.
			</p>

			<input type="file" style="display: none" ref="photo" name="photo" id="photo" @change="onFileChange" />

			<div v-if="!likePhoto">
				<div :class="{ 'form-control--image': imageSent }"
					class="form-control mb-3 d-flex justify-content-between align-items-center"
					@click="$refs['photo'].click()">
					<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"
						v-if="imageSent">
						<path
							d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z"
							fill="#50A773" />
						<path
							d="M8.53033 11.803C8.23744 11.5101 7.76256 11.5101 7.46967 11.803C7.17678 12.0959 7.17678 12.5708 7.46967 12.8637L8.53033 11.803ZM10.6667 15L10.1363 15.5303L10.6988 16.0928L11.2272 15.4983L10.6667 15ZM16.5606 9.49827C16.8357 9.18869 16.8079 8.71463 16.4983 8.43944C16.1887 8.16425 15.7146 8.19214 15.4394 8.50173L16.5606 9.49827ZM7.46967 12.8637L10.1363 15.5303L11.197 14.4697L8.53033 11.803L7.46967 12.8637ZM11.2272 15.4983L16.5606 9.49827L15.4394 8.50173L10.1061 14.5017L11.2272 15.4983Z"
							fill="white" />
					</svg>
					<span>Selecione a Foto</span>

					<!--<div class="image-box"><img v-if="imageSent" :src="form.image" class="" /></div>-->

					<svg width="10" height="18" viewBox="0 0 10 18" fill="none" xmlns="http://www.w3.org/2000/svg">
						<path fill-rule="evenodd" clip-rule="evenodd"
							d="M0.903169 17.0419C0.573854 16.7844 0.535717 16.3322 0.817987 16.0318L7.56019 8.85721L0.817985 1.68259C0.535715 1.38221 0.573853 0.929998 0.903168 0.672533C1.23248 0.415071 1.72827 0.449858 2.01054 0.750229L9.62891 8.85721L2.01054 16.9642C1.72827 17.2646 1.23248 17.2994 0.903169 17.0419Z"
							fill="#3E3E3E" />
					</svg>
				</div>
				<div class="image-box-outer center" v-if="imageSent">
					<img :src="form.image" class="image-box" />
				</div>

				<div class="FotoOk">
					Todos os campos nesta imagem da sua nota fiscal podem ser lidos?
				</div>

				<div class="row">
					<button type="button" class="btn btn-primary btn-lg btn-block" :disabled="!imageSent"
						@click="continuePhoto">
						Sim, Continuar
					</button>
				</div>
			</div>

			<div v-if="likePhoto" ref="section">
				<div class="form-group has-float-label mb-3">
					<div class="" style="position: absolute;top: 10px;right: 0px;">
							<b-button size="sm" variant="link" @click="popUP('nota')">
								<svg data-v-61dd7a3d="" width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
									<path data-v-61dd7a3d="" d="M10.9766 0.492188C9.60156 0.492188 8.30469 0.757813 7.08594 1.28906C5.88281 1.80469 4.82812 2.51563 3.92188 3.42188C3.01562 4.32812 2.30469 5.39062 1.78906 6.60938C1.25781 7.8125 0.992188 9.10938 0.992188 10.5C0.992188 11.875 1.25781 13.1719 1.78906 14.3906C2.30469 15.5938 3.01562 16.6484 3.92188 17.5547C4.82812 18.4609 5.89062 19.1719 7.10938 19.6875C8.3125 20.2188 9.60938 20.4844 11 20.4844C11.7969 20.4844 12.5703 20.3906 13.3203 20.2031C14.0703 20.0312 14.7734 19.7812 15.4297 19.4531C16.1016 19.1094 16.7266 18.7031 17.3047 18.2344C17.8828 17.75 18.3984 17.2188 18.8516 16.6406C18.9922 16.4844 19.0469 16.3047 19.0156 16.1016C18.9844 15.8828 18.8906 15.7109 18.7344 15.5859C18.5625 15.4609 18.375 15.4141 18.1719 15.4453C17.9688 15.4609 17.8047 15.5547 17.6797 15.7266C17.2891 16.2109 16.8516 16.6562 16.3672 17.0625C15.8672 17.4688 15.3359 17.8125 14.7734 18.0938C14.2109 18.375 13.6094 18.5938 12.9688 18.75C12.3281 18.9062 11.6719 18.9844 11 18.9844C9.8125 18.9844 8.70312 18.7578 7.67188 18.3047C6.64062 17.8672 5.74219 17.2656 4.97656 16.5C4.21094 15.7344 3.60938 14.8359 3.17188 13.8047C2.71875 12.7734 2.49219 11.6719 2.49219 10.5C2.49219 9.3125 2.71875 8.20312 3.17188 7.17188C3.60938 6.14062 4.21094 5.24219 4.97656 4.47656C5.74219 3.71094 6.64062 3.10937 7.67188 2.67188C8.70312 2.21875 9.80469 1.99219 10.9766 1.99219C12.1484 1.99219 13.25 2.21875 14.2812 2.67188C15.3125 3.10937 16.2109 3.71875 16.9766 4.5C17.7578 5.26562 18.3672 6.16406 18.8047 7.19531C19.2422 8.22656 19.4609 9.32812 19.4609 10.5C19.4609 10.7031 19.5312 10.8828 19.6719 11.0391C19.8281 11.1797 20.0078 11.25 20.2109 11.25C20.4297 11.25 20.6094 11.1797 20.75 11.0391C20.8906 10.8828 20.9609 10.7031 20.9609 10.5C20.9609 9.10938 20.7031 7.8125 20.1875 6.60938C19.6562 5.39062 18.9375 4.32812 18.0312 3.42188C17.1406 2.51563 16.0859 1.80469 14.8672 1.28906C13.6641 0.757813 12.3672 0.492188 10.9766 0.492188ZM10.9297 6.21094C10.5391 6.21094 10.1875 6.32812 9.875 6.5625C9.57812 6.78125 9.375 7.07031 9.26562 7.42969C9.20312 7.63281 9.07031 7.78906 8.86719 7.89844C8.67969 8.00781 8.48438 8.02344 8.28125 7.94531C8.0625 7.88281 7.89844 7.75781 7.78906 7.57031C7.69531 7.36719 7.67969 7.16406 7.74219 6.96094C7.96094 6.27344 8.35938 5.71094 8.9375 5.27344C9.51562 4.83594 10.1797 4.61719 10.9297 4.61719C11.8516 4.61719 12.6406 4.94531 13.2969 5.60156C13.9531 6.24219 14.2812 7.02344 14.2812 7.94531C14.2812 8.60156 14.1094 9.19531 13.7656 9.72656C13.4375 10.2422 13.0078 10.6406 12.4766 10.9219C12.2266 11.0469 12.0391 11.2031 11.9141 11.3906C11.7891 11.5625 11.7266 11.75 11.7266 11.9531V13.0312C11.7266 13.25 11.6484 13.4375 11.4922 13.5938C11.3359 13.75 11.1484 13.8281 10.9297 13.8281C10.7109 13.8281 10.5234 13.75 10.3672 13.5938C10.2109 13.4375 10.1328 13.25 10.1328 13.0312V11.9531C10.1328 11.3906 10.2891 10.8984 10.6016 10.4766C10.9141 10.0391 11.2891 9.71094 11.7266 9.49219C12.0078 9.35156 12.2344 9.14844 12.4062 8.88281C12.5781 8.60156 12.6641 8.28906 12.6641 7.94531C12.6641 7.46094 12.4922 7.05469 12.1484 6.72656C11.8203 6.38281 11.4141 6.21094 10.9297 6.21094ZM10.9297 16.3594C10.8828 16.3594 10.8281 16.3516 10.7656 16.3359C10.7188 16.3203 10.6719 16.3047 10.625 16.2891C10.5781 16.2734 10.5312 16.25 10.4844 16.2188C10.4375 16.1875 10.3984 16.1562 10.3672 16.125C10.3359 16.0781 10.3047 16.0391 10.2734 16.0078C10.2422 15.9609 10.2109 15.9141 10.1797 15.8672C10.1641 15.8047 10.1484 15.75 10.1328 15.7031C10.1328 15.6562 10.1328 15.6016 10.1328 15.5391C10.1328 15.4922 10.1328 15.4453 10.1328 15.3984C10.1484 15.3359 10.1641 15.2812 10.1797 15.2344C10.2109 15.1875 10.2422 15.1484 10.2734 15.1172C10.3047 15.0703 10.3359 15.0234 10.3672 14.9766C10.3984 14.9453 10.4375 14.9141 10.4844 14.8828C10.5312 14.8516 10.5781 14.8281 10.625 14.8125C10.7656 14.75 10.9141 14.7344 11.0703 14.7656C11.2422 14.7969 11.3828 14.8672 11.4922 14.9766C11.5391 15.0234 11.5703 15.0703 11.5859 15.1172C11.6172 15.1484 11.6484 15.1875 11.6797 15.2344C11.6953 15.2812 11.7109 15.3359 11.7266 15.3984C11.7422 15.4453 11.75 15.4922 11.75 15.5391C11.75 15.6016 11.7422 15.6562 11.7266 15.7031C11.7109 15.75 11.6953 15.8047 11.6797 15.8672C11.6484 15.9141 11.6172 15.9609 11.5859 16.0078C11.5703 16.0391 11.5391 16.0781 11.4922 16.125C11.4609 16.1562 11.4219 16.1875 11.375 16.2188C11.3281 16.25 11.2812 16.2734 11.2344 16.2891C11.1875 16.3047 11.1406 16.3203 11.0938 16.3359C11.0469 16.3516 10.9922 16.3594 10.9297 16.3594Z" fill="#EA1D2C">
									</path>
								</svg>
							</b-button>
						</div>
					<input class="form-control" id="nf-number" v-model="$v.form.nf.$model" type="number"
						placeholder=" " style="width: 87%;"/>
					<label for="nf-number">Número da nota fiscal</label>
				</div>

				<div class="form-group has-float-label mb-3" :class="{ 'form-group--error': $v.form.cnpj.$error }">
					<div class="" style="position: absolute;top: 10px;right: 0px;">
							<b-button size="sm" variant="link" @click="popUP('cnpj')">
								<svg data-v-61dd7a3d="" width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
									<path data-v-61dd7a3d="" d="M10.9766 0.492188C9.60156 0.492188 8.30469 0.757813 7.08594 1.28906C5.88281 1.80469 4.82812 2.51563 3.92188 3.42188C3.01562 4.32812 2.30469 5.39062 1.78906 6.60938C1.25781 7.8125 0.992188 9.10938 0.992188 10.5C0.992188 11.875 1.25781 13.1719 1.78906 14.3906C2.30469 15.5938 3.01562 16.6484 3.92188 17.5547C4.82812 18.4609 5.89062 19.1719 7.10938 19.6875C8.3125 20.2188 9.60938 20.4844 11 20.4844C11.7969 20.4844 12.5703 20.3906 13.3203 20.2031C14.0703 20.0312 14.7734 19.7812 15.4297 19.4531C16.1016 19.1094 16.7266 18.7031 17.3047 18.2344C17.8828 17.75 18.3984 17.2188 18.8516 16.6406C18.9922 16.4844 19.0469 16.3047 19.0156 16.1016C18.9844 15.8828 18.8906 15.7109 18.7344 15.5859C18.5625 15.4609 18.375 15.4141 18.1719 15.4453C17.9688 15.4609 17.8047 15.5547 17.6797 15.7266C17.2891 16.2109 16.8516 16.6562 16.3672 17.0625C15.8672 17.4688 15.3359 17.8125 14.7734 18.0938C14.2109 18.375 13.6094 18.5938 12.9688 18.75C12.3281 18.9062 11.6719 18.9844 11 18.9844C9.8125 18.9844 8.70312 18.7578 7.67188 18.3047C6.64062 17.8672 5.74219 17.2656 4.97656 16.5C4.21094 15.7344 3.60938 14.8359 3.17188 13.8047C2.71875 12.7734 2.49219 11.6719 2.49219 10.5C2.49219 9.3125 2.71875 8.20312 3.17188 7.17188C3.60938 6.14062 4.21094 5.24219 4.97656 4.47656C5.74219 3.71094 6.64062 3.10937 7.67188 2.67188C8.70312 2.21875 9.80469 1.99219 10.9766 1.99219C12.1484 1.99219 13.25 2.21875 14.2812 2.67188C15.3125 3.10937 16.2109 3.71875 16.9766 4.5C17.7578 5.26562 18.3672 6.16406 18.8047 7.19531C19.2422 8.22656 19.4609 9.32812 19.4609 10.5C19.4609 10.7031 19.5312 10.8828 19.6719 11.0391C19.8281 11.1797 20.0078 11.25 20.2109 11.25C20.4297 11.25 20.6094 11.1797 20.75 11.0391C20.8906 10.8828 20.9609 10.7031 20.9609 10.5C20.9609 9.10938 20.7031 7.8125 20.1875 6.60938C19.6562 5.39062 18.9375 4.32812 18.0312 3.42188C17.1406 2.51563 16.0859 1.80469 14.8672 1.28906C13.6641 0.757813 12.3672 0.492188 10.9766 0.492188ZM10.9297 6.21094C10.5391 6.21094 10.1875 6.32812 9.875 6.5625C9.57812 6.78125 9.375 7.07031 9.26562 7.42969C9.20312 7.63281 9.07031 7.78906 8.86719 7.89844C8.67969 8.00781 8.48438 8.02344 8.28125 7.94531C8.0625 7.88281 7.89844 7.75781 7.78906 7.57031C7.69531 7.36719 7.67969 7.16406 7.74219 6.96094C7.96094 6.27344 8.35938 5.71094 8.9375 5.27344C9.51562 4.83594 10.1797 4.61719 10.9297 4.61719C11.8516 4.61719 12.6406 4.94531 13.2969 5.60156C13.9531 6.24219 14.2812 7.02344 14.2812 7.94531C14.2812 8.60156 14.1094 9.19531 13.7656 9.72656C13.4375 10.2422 13.0078 10.6406 12.4766 10.9219C12.2266 11.0469 12.0391 11.2031 11.9141 11.3906C11.7891 11.5625 11.7266 11.75 11.7266 11.9531V13.0312C11.7266 13.25 11.6484 13.4375 11.4922 13.5938C11.3359 13.75 11.1484 13.8281 10.9297 13.8281C10.7109 13.8281 10.5234 13.75 10.3672 13.5938C10.2109 13.4375 10.1328 13.25 10.1328 13.0312V11.9531C10.1328 11.3906 10.2891 10.8984 10.6016 10.4766C10.9141 10.0391 11.2891 9.71094 11.7266 9.49219C12.0078 9.35156 12.2344 9.14844 12.4062 8.88281C12.5781 8.60156 12.6641 8.28906 12.6641 7.94531C12.6641 7.46094 12.4922 7.05469 12.1484 6.72656C11.8203 6.38281 11.4141 6.21094 10.9297 6.21094ZM10.9297 16.3594C10.8828 16.3594 10.8281 16.3516 10.7656 16.3359C10.7188 16.3203 10.6719 16.3047 10.625 16.2891C10.5781 16.2734 10.5312 16.25 10.4844 16.2188C10.4375 16.1875 10.3984 16.1562 10.3672 16.125C10.3359 16.0781 10.3047 16.0391 10.2734 16.0078C10.2422 15.9609 10.2109 15.9141 10.1797 15.8672C10.1641 15.8047 10.1484 15.75 10.1328 15.7031C10.1328 15.6562 10.1328 15.6016 10.1328 15.5391C10.1328 15.4922 10.1328 15.4453 10.1328 15.3984C10.1484 15.3359 10.1641 15.2812 10.1797 15.2344C10.2109 15.1875 10.2422 15.1484 10.2734 15.1172C10.3047 15.0703 10.3359 15.0234 10.3672 14.9766C10.3984 14.9453 10.4375 14.9141 10.4844 14.8828C10.5312 14.8516 10.5781 14.8281 10.625 14.8125C10.7656 14.75 10.9141 14.7344 11.0703 14.7656C11.2422 14.7969 11.3828 14.8672 11.4922 14.9766C11.5391 15.0234 11.5703 15.0703 11.5859 15.1172C11.6172 15.1484 11.6484 15.1875 11.6797 15.2344C11.6953 15.2812 11.7109 15.3359 11.7266 15.3984C11.7422 15.4453 11.75 15.4922 11.75 15.5391C11.75 15.6016 11.7422 15.6562 11.7266 15.7031C11.7109 15.75 11.6953 15.8047 11.6797 15.8672C11.6484 15.9141 11.6172 15.9609 11.5859 16.0078C11.5703 16.0391 11.5391 16.0781 11.4922 16.125C11.4609 16.1562 11.4219 16.1875 11.375 16.2188C11.3281 16.25 11.2812 16.2734 11.2344 16.2891C11.1875 16.3047 11.1406 16.3203 11.0938 16.3359C11.0469 16.3516 10.9922 16.3594 10.9297 16.3594Z" fill="#EA1D2C">
									</path>
								</svg>
							</b-button>
						</div>
					<input class="form-control" style="width: 87%;" @keyup="$v.form.cnpj.$touch()" @input="$v.form.cnpj.$touch()" :class="{ 'is-invalid': $v.form.cnpj.$error }" id="nf-cnpj" v-mask="'##.###.###/####-##'" v-model="$v.form.cnpj.$model" type="text" placeholder=" " />
					<label for="nf-cnpj">CNPJ </label>
					<div class="invalid-feedback" v-if="!$v.form.cnpj.minLength">Digite corretamente o CNPJ</div>
					<div class="invalid-feedback" v-if="!$v.form.cnpj.CNPJValidate">CNPJ inválido</div>
				</div>

				<div class="form-group has-float-label">
					<div class="" style="position: absolute;top: 10px;right: 0px;">
							<b-button size="sm" variant="link" @click="popUP('data')">
								<svg data-v-61dd7a3d="" width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
									<path data-v-61dd7a3d="" d="M10.9766 0.492188C9.60156 0.492188 8.30469 0.757813 7.08594 1.28906C5.88281 1.80469 4.82812 2.51563 3.92188 3.42188C3.01562 4.32812 2.30469 5.39062 1.78906 6.60938C1.25781 7.8125 0.992188 9.10938 0.992188 10.5C0.992188 11.875 1.25781 13.1719 1.78906 14.3906C2.30469 15.5938 3.01562 16.6484 3.92188 17.5547C4.82812 18.4609 5.89062 19.1719 7.10938 19.6875C8.3125 20.2188 9.60938 20.4844 11 20.4844C11.7969 20.4844 12.5703 20.3906 13.3203 20.2031C14.0703 20.0312 14.7734 19.7812 15.4297 19.4531C16.1016 19.1094 16.7266 18.7031 17.3047 18.2344C17.8828 17.75 18.3984 17.2188 18.8516 16.6406C18.9922 16.4844 19.0469 16.3047 19.0156 16.1016C18.9844 15.8828 18.8906 15.7109 18.7344 15.5859C18.5625 15.4609 18.375 15.4141 18.1719 15.4453C17.9688 15.4609 17.8047 15.5547 17.6797 15.7266C17.2891 16.2109 16.8516 16.6562 16.3672 17.0625C15.8672 17.4688 15.3359 17.8125 14.7734 18.0938C14.2109 18.375 13.6094 18.5938 12.9688 18.75C12.3281 18.9062 11.6719 18.9844 11 18.9844C9.8125 18.9844 8.70312 18.7578 7.67188 18.3047C6.64062 17.8672 5.74219 17.2656 4.97656 16.5C4.21094 15.7344 3.60938 14.8359 3.17188 13.8047C2.71875 12.7734 2.49219 11.6719 2.49219 10.5C2.49219 9.3125 2.71875 8.20312 3.17188 7.17188C3.60938 6.14062 4.21094 5.24219 4.97656 4.47656C5.74219 3.71094 6.64062 3.10937 7.67188 2.67188C8.70312 2.21875 9.80469 1.99219 10.9766 1.99219C12.1484 1.99219 13.25 2.21875 14.2812 2.67188C15.3125 3.10937 16.2109 3.71875 16.9766 4.5C17.7578 5.26562 18.3672 6.16406 18.8047 7.19531C19.2422 8.22656 19.4609 9.32812 19.4609 10.5C19.4609 10.7031 19.5312 10.8828 19.6719 11.0391C19.8281 11.1797 20.0078 11.25 20.2109 11.25C20.4297 11.25 20.6094 11.1797 20.75 11.0391C20.8906 10.8828 20.9609 10.7031 20.9609 10.5C20.9609 9.10938 20.7031 7.8125 20.1875 6.60938C19.6562 5.39062 18.9375 4.32812 18.0312 3.42188C17.1406 2.51563 16.0859 1.80469 14.8672 1.28906C13.6641 0.757813 12.3672 0.492188 10.9766 0.492188ZM10.9297 6.21094C10.5391 6.21094 10.1875 6.32812 9.875 6.5625C9.57812 6.78125 9.375 7.07031 9.26562 7.42969C9.20312 7.63281 9.07031 7.78906 8.86719 7.89844C8.67969 8.00781 8.48438 8.02344 8.28125 7.94531C8.0625 7.88281 7.89844 7.75781 7.78906 7.57031C7.69531 7.36719 7.67969 7.16406 7.74219 6.96094C7.96094 6.27344 8.35938 5.71094 8.9375 5.27344C9.51562 4.83594 10.1797 4.61719 10.9297 4.61719C11.8516 4.61719 12.6406 4.94531 13.2969 5.60156C13.9531 6.24219 14.2812 7.02344 14.2812 7.94531C14.2812 8.60156 14.1094 9.19531 13.7656 9.72656C13.4375 10.2422 13.0078 10.6406 12.4766 10.9219C12.2266 11.0469 12.0391 11.2031 11.9141 11.3906C11.7891 11.5625 11.7266 11.75 11.7266 11.9531V13.0312C11.7266 13.25 11.6484 13.4375 11.4922 13.5938C11.3359 13.75 11.1484 13.8281 10.9297 13.8281C10.7109 13.8281 10.5234 13.75 10.3672 13.5938C10.2109 13.4375 10.1328 13.25 10.1328 13.0312V11.9531C10.1328 11.3906 10.2891 10.8984 10.6016 10.4766C10.9141 10.0391 11.2891 9.71094 11.7266 9.49219C12.0078 9.35156 12.2344 9.14844 12.4062 8.88281C12.5781 8.60156 12.6641 8.28906 12.6641 7.94531C12.6641 7.46094 12.4922 7.05469 12.1484 6.72656C11.8203 6.38281 11.4141 6.21094 10.9297 6.21094ZM10.9297 16.3594C10.8828 16.3594 10.8281 16.3516 10.7656 16.3359C10.7188 16.3203 10.6719 16.3047 10.625 16.2891C10.5781 16.2734 10.5312 16.25 10.4844 16.2188C10.4375 16.1875 10.3984 16.1562 10.3672 16.125C10.3359 16.0781 10.3047 16.0391 10.2734 16.0078C10.2422 15.9609 10.2109 15.9141 10.1797 15.8672C10.1641 15.8047 10.1484 15.75 10.1328 15.7031C10.1328 15.6562 10.1328 15.6016 10.1328 15.5391C10.1328 15.4922 10.1328 15.4453 10.1328 15.3984C10.1484 15.3359 10.1641 15.2812 10.1797 15.2344C10.2109 15.1875 10.2422 15.1484 10.2734 15.1172C10.3047 15.0703 10.3359 15.0234 10.3672 14.9766C10.3984 14.9453 10.4375 14.9141 10.4844 14.8828C10.5312 14.8516 10.5781 14.8281 10.625 14.8125C10.7656 14.75 10.9141 14.7344 11.0703 14.7656C11.2422 14.7969 11.3828 14.8672 11.4922 14.9766C11.5391 15.0234 11.5703 15.0703 11.5859 15.1172C11.6172 15.1484 11.6484 15.1875 11.6797 15.2344C11.6953 15.2812 11.7109 15.3359 11.7266 15.3984C11.7422 15.4453 11.75 15.4922 11.75 15.5391C11.75 15.6016 11.7422 15.6562 11.7266 15.7031C11.7109 15.75 11.6953 15.8047 11.6797 15.8672C11.6484 15.9141 11.6172 15.9609 11.5859 16.0078C11.5703 16.0391 11.5391 16.0781 11.4922 16.125C11.4609 16.1562 11.4219 16.1875 11.375 16.2188C11.3281 16.25 11.2812 16.2734 11.2344 16.2891C11.1875 16.3047 11.1406 16.3203 11.0938 16.3359C11.0469 16.3516 10.9922 16.3594 10.9297 16.3594Z" fill="#EA1D2C">
									</path>
								</svg>
							</b-button>
						</div>
					<!-- <input class="form-control" id="nf-date" type="tel" placeholder=" " v-maska="'##/##/####'"/> -->
					<input class="form-control" id="nf-date" type="text" v-model="$v.form.purchaseDate.$model"
						onfocus="(this.type='date')" style="width: 87%;line-height: 44px" placeholder=" " />
					<label for="nf-date">Data da compra</label>
					
				</div>

				<h6 class="text-primary mb-4">Itens na nota fiscal</h6>

				<strong class="text-center d-inline-block w-100 text-muted" v-if="form.products <= 0">Nenhum item adicionado</strong>

				<div class="box" v-for="(product, key) in $v.form.products.$each.$iter" :key="key">
					<h6 class="mb-2 product-title d-flex align-items-center justify-content-between">
						<span class=""> Produto {{ parseInt(key) + 1 }} </span>

						<div class="">
							<b-button size="sm" variant="link" @click="form.products.splice(key, 1)">
								<svg fill="#EA1D2C" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48" width="48px"
									height="48px">
									<path fill="none" stroke="#EA1D2C" stroke-miterlimit="10" stroke-width="3"
										d="M29.5,11.5V11c0-3.038-2.462-5.5-5.5-5.5	s-5.5,2.462-5.5,5.5v0.5" />
									<line x1="6.5" x2="41.5" y1="11.5" y2="11.5" fill="none" stroke="#EA1D2C"
										stroke-linecap="round" stroke-miterlimit="10" stroke-width="3" />
									<line x1="20.5" x2="20.5" y1="19.5" y2="34.5" fill="none" stroke="#EA1D2C"
										stroke-linecap="round" stroke-miterlimit="10" stroke-width="3" />
									<line x1="27.5" x2="27.5" y1="19.5" y2="34.5" fill="none" stroke="#EA1D2C"
										stroke-linecap="round" stroke-miterlimit="10" stroke-width="3" />
									<path fill="none" stroke="#EA1D2C" stroke-linecap="round" stroke-miterlimit="10"
										stroke-width="3"
										d="M10,11.5l2.65,27.385	c0.198,2.05,1.922,3.615,3.981,3.615h14.737c2.06,0,3.783-1.564,3.981-3.615L38,11.5" />
								</svg>
							</b-button>
						</div>
					</h6>
					<div class="pt-0">
						<div class="form-group has-float-label">
							<input class="form-control" :id="`product-${key}`" v-model="product.name.$model" type="text"
								placeholder=" " :class="{ 'is-invalid': product.name.$error }" />
							<label :for="`product-${key}`">Descrição do produto conforme NF</label>
							<div class="invalid-feedback" v-if="!product.name.minLength">Mínimo de 6 caracteres</div>
							<div class="invalid-feedback" v-if="!product.name.alpha">Deve ter pelo menos 1 letra</div>
						</div>

						<div class="row">
							<div class="col-8">
								<div class="form-group has-float-label">
									<!-- <input class="form-control" :id="`product-value-${key}`" type="text" placeholder=" "/> -->
									<CurrencyInput v-model="product.value.$model" :inputPlaceHolder="' '"
										:id="`product-value-${key}`" :options="inputOpts" />
									<label :for="`product-value-${key}`">Valor Unitário</label>
								</div>
							</div>
							<div class="col">
								<product-counter v-model="product.quantity.$model" />
							</div>
						</div>
					</div>
				</div>
				<div class="text-center mt-3 pt-3 mb-4">
					<button class="text-primary btn-small btn btn-link font-weight-bold" @click.prevent="addProduct()">
						<span v-if="form.products.length <= 0">Adicionar um produto da nota</span>
						<span v-else>Adicionar outro produto da mesma nota</span>
					</button>
				</div>

				<div class="notes">
					<h6 class="mb-3">
						<div class="float-right text-muted">{{ form.comments.length }}/50</div>
						<svg width="14" height="12" viewBox="0 0 14 12" fill="none" xmlns="http://www.w3.org/2000/svg">
							<path
								d="M12.5002 0H1.4935C0.853496 0 0.333496 0.52 0.333496 1.16V7.36C0.333496 8 0.860163 8.52667 1.50016 8.52667H3.50683V11.36C3.50683 11.56 3.62683 11.74 3.80683 11.82C3.8735 11.8467 3.94016 11.86 4.00683 11.86C4.12683 11.86 4.24683 11.8133 4.34016 11.7267L7.86016 8.52667H12.5002C13.1402 8.52667 13.6602 8.00667 13.6602 7.36667V1.16C13.6668 0.52 13.1468 0 12.5002 0ZM8.86016 5.83333H5.14016C4.86016 5.83333 4.64016 5.61333 4.64016 5.33333C4.64016 5.05333 4.86683 4.83333 5.14016 4.83333H8.86016C9.1335 4.83333 9.36016 5.06 9.36016 5.33333C9.36016 5.60667 9.1335 5.83333 8.86016 5.83333ZM9.6735 3.69333H4.32683C4.0535 3.69333 3.82683 3.46667 3.82683 3.19333C3.82683 2.92 4.0535 2.69333 4.32683 2.69333H9.6735C9.94683 2.69333 10.1735 2.92 10.1735 3.19333C10.1735 3.46667 9.94683 3.69333 9.6735 3.69333Z"
								fill="#3E3E3E" />
						</svg>
						Alguma observação?
					</h6>
					<textarea maxlength="50" v-model="form.comments" class="form-control"
						placeholder="Ex: Compra realizada em estabelecimento sem NF eletrônica"></textarea>
				</div>

				<div class="total text-right mt-5">
					<span class="text-muted font-weight-bold">Valor total</span>
					<strong class="h5 font-weight-bold">R$ {{ total }}</strong>
				</div>

				<ifood-footer class="p-3" style="background-color: #fff">
					<button type="button" class="btn btn-primary btn-lg btn-block" :disabled="$v.form.$invalid"
						@click="sendInvoice()">
						Continuar
					</button>
				</ifood-footer>
			</div>
		</div>
		<ifood-modal v-show="isModalVisible" @close="closeModal">
			<template v-slot:body>
				<div class="d-flex align-items-center h-100 text-center px-3" v-if="errorSend">
					<div>
						<img src="../assets/svg/motoboy-01.svg" style="max-width: 100%; max-height: 255px"
							class="mb-3" />
						<h5>Tivemos um problema ao enviar</h5>
						<p>Não conseguimos enviar sua solicitação, você pode tentar novamente.</p>
					</div>
				</div>
				<div class="d-flex align-items-center h-100 text-center px-3" v-else>
					<div>
						<img src="../assets/svg/motoboy-02.svg" style="max-width: 100%; max-height: 255px"
							class="mb-3" />
						<h5>Solicitação de reembolso realizada</h5>
						<p>Iremos analisar sua solicitação de reembolso.</p>
					</div>
				</div>
			</template>

			<template v-slot:footer>
				<ifood-footer class="p-3" style="background-color: #fff" v-if="errorSend">
					<button @click="FailEvent()" class="btn btn-primary btn-lg btn-block">
						Criar nova solicitação
					</button>
				</ifood-footer>

				<ifood-footer class="p-3" style="background-color: #fff" v-else>
					<button class="btn btn-primary btn-lg btn-block" @click="SuccessEvent()">
						Ok, entendi
					</button>
				</ifood-footer>
			</template>
		</ifood-modal>




		<ifood-modal v-show="isModalVisiblePoPUp" @close="closeModalPop()">
			<template v-slot:body>
				<div class="d-flex align-items-center h-100 text-center px-3" @click="closeModalPop()">
					<div>
						<img src="../assets/002-data.png" style="max-width: 100%; max-height: 255px"
							class="mb-3" v-if="imgTips=='data'" />
						<img src="../assets/001-nota.png" style="max-width: 100%; max-height: 255px"
							class="mb-3" v-if="imgTips=='nota'" />
						<img src="../assets/003-cnpj.png" style="max-width: 100%; max-height: 255px"
							class="mb-3" v-if="imgTips=='cnpj'" />
					</div>
					<ifood-footer class="p-3" style="background-color: #fff" >
						<button class="btn btn-primary btn-lg btn-block" @click="closeModalPop()">
							Ok, entendi
						</button>
					</ifood-footer>
				</div>
			</template>
		</ifood-modal>
	</div>
</template>

<script>
import Product from "../components/Product.vue";
import { mapGetters, mapActions } from "vuex";
import ifoodFooter from "@/components/Footer.vue";
import ifoodModal from "@/components/Modal.vue";
import { required, minLength, helpers  } from "vuelidate/lib/validators";

import amplitude from "amplitude-js";
import Faster, { FasterConfiguration } from "faster-sdk-js";
import { EventBuilder } from "faster-sdk-js";

import CurrencyInput from "../components/CurrencyInput.vue";

function isCNPJValid(cnpj) {

	cnpj = cnpj.replace(/[^\d]+/g, '');
	if (cnpj == '') return false;
	if (cnpj.length != 14) return false;

	if (cnpj == "00000000000000" ||
		cnpj == "11111111111111" ||
		cnpj == "22222222222222" ||
		cnpj == "33333333333333" ||
		cnpj == "44444444444444" ||
		cnpj == "55555555555555" ||
		cnpj == "66666666666666" ||
		cnpj == "77777777777777" ||
		cnpj == "88888888888888" ||
		cnpj == "99999999999999")
		return false;

	let tamanho = cnpj.length - 2
	let numeros = cnpj.substring(0, tamanho);
	let digitos = cnpj.substring(tamanho);
	let soma = 0;
	let pos = tamanho - 7;

	for (let i = tamanho; i >= 1; i--) {
		soma += numeros.charAt(tamanho - i) * pos--;
		if (pos < 2) pos = 9;
	}
	let resultado = soma % 11 < 2 ? 0 : 11 - soma % 11;

	if (resultado != digitos.charAt(0)) return false;
	else return true;
}

const CNPJValidate = (value) => (isCNPJValid(value));

const alpha = helpers.regex('alpha', /^\d*[a-zA-Z][a-zA-Z0-9]*$/)

const FormData = require("form-data");
export default {
	name: "Rules",
	directives: {},
	components: {
		Product,
		CurrencyInput,
		ifoodFooter,
		ifoodModal,
	},
	data() {
		return {
			isModalVisible: false,
			imgTips: "",
			errorSend: false,
			inputOpts: {
				locale: "pt-BR",
				currency: "BRL",
				currencyDisplay: "symbol",
				hideCurrencySymbolOnFocus: true,
				hideGroupingSeparatorOnFocus: true,
				hideNegligibleDecimalDigitsOnFocus: true,
				autoDecimalDigits: false,
				autoSign: true,
				useGrouping: true,
				accountingSign: true,
			},
			form: {
				purchaseDate: "",
				nf: "",
				image: "",
				products: [{
					name: "",
					value: 0,
					quantity: 1
				}],
				cnpj: '',
				comments: "",
			},
			urlState: "",
			idState: "",
			imageSent: false,
			isModalVisiblePoPUp: false,
			likePhoto: false,
		};
	},
	methods: {
		continuePhoto() {
			this.likePhoto = true;
		},

		...mapActions({
			fetchUploadLink: "fetchUploadLink",
			sendPhoto: "sendPhoto",
			validateInvoice: "validateInvoice",
		}),
		FailEvent() {
			const configuration = new FasterConfiguration(
				"c352c9f1-6120-4ef5-87e3-c5cec5eb1cda",
				"oIwfANqzIAItf97FHJulmwvN"
			);
			Faster.configure(configuration);
			const fasterAnalyticsInstance = Faster.start();
			const eventBuilder = new EventBuilder("Click_CovidRefund_StartRequest", 0);
			const event_faster = eventBuilder
				.id(localStorage.getItem("id"))
				.externalId(localStorage.getItem("worker_id"))
				.dimension("driverId", localStorage.getItem("worker_id"))
				.dimension("currentPage", "RequestFail")
				.build();
			fasterAnalyticsInstance.event.register(event_faster);
			//End
			//amplitude
			var userId = localStorage.getItem("worker_id");
			amplitude.getInstance().init("acd3720cc16f656e0f48bf417916784d", userId);
			var event = "Click_CovidRefund_StartRequest";
			var eventProperties = {
				driver_Id: localStorage.getItem("worker_id"),
				driver_uuid: localStorage.getItem("id"),
				currentPage: "RequestFail",
				timestamp: Date.now(),
			};
			amplitude.getInstance().logEvent(event, eventProperties);

			this.$router.push("/NewRefundWarning");
		},
		SuccessEvent() {
			const configuration = new FasterConfiguration(
				"c352c9f1-6120-4ef5-87e3-c5cec5eb1cda",
				"oIwfANqzIAItf97FHJulmwvN"
			);
			Faster.configure(configuration);
			const fasterAnalyticsInstance = Faster.start();
			const eventBuilder = new EventBuilder(
				"Click_CovidRefund_ContinueRequestSuccess",
				0
			);
			const event_faster = eventBuilder
				.id(localStorage.getItem("id"))
				.externalId(localStorage.getItem("worker_id"))
				.dimension("driverId", localStorage.getItem("worker_id"))
				.build();
			fasterAnalyticsInstance.event.register(event_faster);
			//End
			//amplitude
			var userId = localStorage.getItem("worker_id");
			amplitude.getInstance().init("acd3720cc16f656e0f48bf417916784d", userId);
			var event = "Click_CovidRefund_ContinueRequestSuccess";
			var eventProperties = {
				driver_Id: localStorage.getItem("worker_id"),
				driver_uuid: localStorage.getItem("id"),
				timestamp: Date.now(),
			};
			amplitude.getInstance().logEvent(event, eventProperties);

			this.$router.push("/Dashboard");
		},
		popUP(item){
			this.imgTips = item
			this.isModalVisiblePoPUp = true;
		},
		closeModalPop(){
			this.isModalVisiblePoPUp = false;
		},
		showModal() {
			this.isModalVisible = true;

			if (this.errorSend) {
				const configuration = new FasterConfiguration(
					"c352c9f1-6120-4ef5-87e3-c5cec5eb1cda",
					"oIwfANqzIAItf97FHJulmwvN"
				);
				Faster.configure(configuration);
				const fasterAnalyticsInstance = Faster.start();
				const eventBuilder = new EventBuilder("View_CovidRefund_RequestFail", 0);
				const event_faster = eventBuilder
					.id(localStorage.getItem("id"))
					.externalId(localStorage.getItem("worker_id"))
					.dimension("driverId", localStorage.getItem("worker_id"))
					.build();
				fasterAnalyticsInstance.event.register(event_faster);
				//End
				//amplitude
				var userId = localStorage.getItem("worker_id");
				amplitude.getInstance().init("acd3720cc16f656e0f48bf417916784d", userId);
				var event = "View_CovidRefund_RequestFail";
				var eventProperties = {
					driver_Id: localStorage.getItem("worker_id"),
					driver_uuid: localStorage.getItem("id"),
					timestamp: Date.now(),
				};
				amplitude.getInstance().logEvent(event, eventProperties);
			} else {
				const configuration = new FasterConfiguration(
					"c352c9f1-6120-4ef5-87e3-c5cec5eb1cda",
					"oIwfANqzIAItf97FHJulmwvN"
				);
				Faster.configure(configuration);
				const fasterAnalyticsInstance = Faster.start();
				const eventBuilder = new EventBuilder("View_CovidRefund_RequestSuccess", 0);
				const event_faster = eventBuilder
					.id(localStorage.getItem("id"))
					.externalId(localStorage.getItem("worker_id"))
					.dimension("driverId", localStorage.getItem("worker_id"))
					.build();
				fasterAnalyticsInstance.event.register(event_faster);
				//End
				//amplitude
				var userId = localStorage.getItem("worker_id");
				amplitude.getInstance().init("acd3720cc16f656e0f48bf417916784d", userId);
				var event = "View_CovidRefund_RequestSuccess";
				var eventProperties = {
					driver_Id: localStorage.getItem("worker_id"),
					driver_uuid: localStorage.getItem("id"),
					timestamp: Date.now(),
				};
				amplitude.getInstance().logEvent(event, eventProperties);
			}
		},
		closeModal() {
			this.errorSend = !this.errorSend;
			this.isModalVisible = !this.isModalVisible;
			this.isModalVisiblePoPUp = !this.isModalVisiblePoPUp;
		},
		addProduct() {
			const configuration = new FasterConfiguration(
				"c352c9f1-6120-4ef5-87e3-c5cec5eb1cda",
				"oIwfANqzIAItf97FHJulmwvN"
			);
			Faster.configure(configuration);
			const fasterAnalyticsInstance = Faster.start();
			const eventBuilder = new EventBuilder("Click_CovidRefund_RefundFormAddProduct", 0);
			const event_faster = eventBuilder
				.id(localStorage.getItem("id"))
				.externalId(localStorage.getItem("worker_id"))
				.dimension("driverId", localStorage.getItem("worker_id"))
				.build();
			fasterAnalyticsInstance.event.register(event_faster);
			//End
			//amplitude
			var userId = localStorage.getItem("worker_id");
			amplitude.getInstance().init("acd3720cc16f656e0f48bf417916784d", userId);
			var event = "Click_CovidRefund_RefundFormAddProduct";
			var eventProperties = {
				driver_Id: localStorage.getItem("worker_id"),
				driver_uuid: localStorage.getItem("id"),
				timestamp: Date.now(),
			};
			amplitude.getInstance().logEvent(event, eventProperties);

			this.form.products.push({
				name: "",
				value: 0,
				quantity: 0
			});
		},
		async sendInvoice() {
			console.log(this.$v);
			if (this.$v.form.$invalid) {
				console.log("N VAI");
			} else {
				const configuration = new FasterConfiguration(
					"c352c9f1-6120-4ef5-87e3-c5cec5eb1cda",
					"oIwfANqzIAItf97FHJulmwvN"
				);
				Faster.configure(configuration);
				const fasterAnalyticsInstance = Faster.start();
				const eventBuilder = new EventBuilder("Click_CovidRefund_SendRefundForm", 0);
				const event_faster = eventBuilder
					.id(localStorage.getItem("id"))
					.externalId(localStorage.getItem("worker_id"))
					.dimension("driverId", localStorage.getItem("worker_id"))
					.build();
				fasterAnalyticsInstance.event.register(event_faster);
				//End
				//amplitude
				var userId = localStorage.getItem("worker_id");
				amplitude.getInstance().init("acd3720cc16f656e0f48bf417916784d", userId);
				var event = "Click_CovidRefund_SendRefundForm";
				var eventProperties = {
					driver_Id: localStorage.getItem("worker_id"),
					driver_uuid: localStorage.getItem("id"),

					timestamp: Date.now(),
				};
				amplitude.getInstance().logEvent(event, eventProperties);

				try {
					let cloneForm = JSON.parse(JSON.stringify(this.form));
					let validateResponse = await this.validateInvoice({
						id: this.idState,
						payload: cloneForm,
					});
					console.log(validateResponse);
					this.errorSend = false;
					this.isModalVisible = true;
					this.showModal();
					// this.$router.push('/dashboard')
				} catch (error) {
					if (error.response.status === 409) {
						this.$toast.error(error.response.data.message, {
							position: "top"
						});
					} else {
						this.errorSend = true;
						this.isModalVisible = true;
						this.showModal();
					}
				}
				// 66180696000193
				// 11/01/2022
				// 003991
				// ALCOOL GEL SEPTPRO PUMP 440G 13,50
				// MASCARA CICURG INF COLOR FUN 19,50
			}
		},
		async onFileChange(e) {
			let loader = this.$loading.show();
			const file = e.target.files[0];
			this.form.image = URL.createObjectURL(file);
			try {
				let response = await this.fetchUploadLink();
				this.urlState = response.url;
				this.idState = response.id;
				await this.sendPhoto({
					url: this.urlState,
					formData: file
				});
				this.imageSent = true;
				loader.hide();
			} catch (error) {
				console.log(error);
				this.errorSend = !this.errorSend;
				this.isModalVisible = !this.isModalVisible;
				loader.hide();
			}
		},
	},
	computed: {
		total() {
			let tempValue = 0;
			this.form.products.forEach((element) => {
				console.log(element);
				tempValue = element.value * element.quantity + tempValue;
			});
			console.log(tempValue);
			return tempValue.toFixed(2);
		},
	},
	validations: {
		form: {
			nf: {
				required
			},
			purchaseDate: {
				required
			},
			cnpj: {
				required,
				minLength: minLength(18),
				CNPJValidate
			},
			products: {
				required,
				$each: {
					name: {
						required,
						minLength: minLength(6),
					},
					value: {
						required
					},
					quantity: {
						required
					},
				},
			},
		},
	},
	mounted() {
		window.addEventListener("scroll", this.handleScroll);
		const configuration = new FasterConfiguration(
			"c352c9f1-6120-4ef5-87e3-c5cec5eb1cda",
			"oIwfANqzIAItf97FHJulmwvN"
		);
		Faster.configure(configuration);
		const fasterAnalyticsInstance = Faster.start();
		const eventBuilder = new EventBuilder("View_CovidRefund_RefundForm", 0);
		const event_faster = eventBuilder
			.id(localStorage.getItem("id"))
			.externalId(localStorage.getItem("worker_id"))
			.dimension("driverId", localStorage.getItem("worker_id"))
			.build();
		fasterAnalyticsInstance.event.register(event_faster);
		//End
		//amplitude
		var userId = localStorage.getItem("worker_id");
		amplitude.getInstance().init("acd3720cc16f656e0f48bf417916784d", userId);
		var event = "View_CovidRefund_RefundForm";
		var eventProperties = {
			driver_Id: localStorage.getItem("worker_id"),
			driver_uuid: localStorage.getItem("id"),
			timestamp: Date.now(),
		};
		amplitude.getInstance().logEvent(event, eventProperties);
	},
};
</script>

<style lang="scss" scoped>
h1 {
  font-size: 1.5rem;
  margin-bottom: 20px;
}

.FotoOk {
  /* Botões/B3 - 14px Medium */
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  margin-bottom: 16px;
  /* or 143% */

  text-align: center;
  letter-spacing: 0.1px;

  /* Black #3E3E3E */

  color: #3e3e3e;
}

.box {
  // border-bottom: 1px solid $gray-5;
  margin-bottom: 1rem;
}

.product-title {
  svg {
    max-width: 20px;
    max-height: 20px;
    stroke: $red;
  }
}
</style>
